import { Reducer } from 'react';

import {
  TeamMemberTransitionDisabledReason,
  TeamMemberTransitionInvitationState,
  TeamMemberTransitionRole,
} from '__generated__/GQL';
import {
  EditableRole,
  MemberInformationRoleFormSchema,
} from 'features/Team/components/MemberInformationRoleForm/schema';

type Transition = {
  role: TeamMemberTransitionRole;
  isDisabled: boolean;
  disabledReason: TeamMemberTransitionDisabledReason | null;
  requiringInvitation: TeamMemberTransitionInvitationState;
};

type TeamMemberInfo = {
  cuid: string;
  email: string;
  firstName: string;
  lastName: string;
  role: EditableRole;
};

export type State = {
  isFreeRolesOnly: boolean;
  identity?: TeamMemberInfo;
  memberRole: MemberInformationRoleFormSchema;
  transitions?: Map<Transition['role'], Transition>;
};

export type Action =
  | {
      type: 'SUBMIT_ROLE';
      payload: MemberInformationRoleFormSchema;
    }
  | {
      type: 'INITIALIZE_TEAM_MEMBER_INFO';
      payload: TeamMemberInfo;
    }
  | {
      type: 'INITIALIZE_TRANSITIONS';
      payload: Transition[];
    };

export const memberInformationRoleReducer: Reducer<State, Action> = (
  state,
  action,
) => {
  switch (action.type) {
    case 'SUBMIT_ROLE':
      return {
        ...state,
        memberRole: action.payload,
      };
    case 'INITIALIZE_TEAM_MEMBER_INFO':
      return {
        ...state,
        identity: action.payload,
        memberRole: {
          role: action.payload.role ?? state.memberRole.role,
        },
      };
    case 'INITIALIZE_TRANSITIONS':
      return {
        ...state,
        transitions: new Map(
          action.payload.map<[Transition['role'], Transition]>((transition) => [
            transition.role,
            transition,
          ]),
        ),
      };
    default:
      return state;
  }
};
